import { Pipe, PipeTransform } from '@angular/core';
import * as locale from 'date-fns/esm/locale';
import format from 'date-fns/format';
import * as moment from 'moment';
import * as timeZoneData from '../../../assets/timezone.json';
import * as momenttz from 'moment-timezone';

@Pipe({
  name: 'custWeekName',
})
export class CustWeekNamePipe implements PipeTransform {
  transform(day: any, dateFunctionConfig?: any): any {
    return format(moment(day, 'dddd').toDate(), dateFunctionConfig.weekNameFormat, { locale: locale[dateFunctionConfig.locale] });
  }
}

@Pipe({
  name: 'custDate',
})
export class CustomAgileDate implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any): any {
    if (date != '' && date != 'NA') {
      return format(new Date(moment(date).toDate()), dateFunctionConfig.dateFormat, { locale: locale[dateFunctionConfig.locale] });
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'custTimeZone',
})
export class CustTimeZone implements PipeTransform {
  transform(date: any, timeZone: string): any {
    const timeZoneList: any[] = (timeZoneData as any).default;
    const extractedTimeZone = timeZoneList.find((time) => time.text.startsWith(timeZone?.split(';')[0]));
    let finalDate = extractedTimeZone ? extractedTimeZone.utc[0] : '';
    return moment.utc(date).tz(finalDate).format('YYYY-MM-DDTHH:mm:ss');
  }
}

@Pipe({
  name: 'custDateAndTime',
})
export class CustDateAndTime implements PipeTransform {
  transform(timestamp: any): any {
    const date = moment.utc(timestamp).local();
    return date.format('YYYY-MM-DD HH:mm:ss');
  }
}

@Pipe({
  name: 'custDateEnhance',
})
export class CustomDateEnhancePipe implements PipeTransform {
  transform(dateEnhance: any, dateFunctionConfig?: any): any {
    if (dateEnhance != '' && dateEnhance != 'NA') {
      let arr = [];
      dateEnhance.forEach((date) => {
        arr.push(
          format(new Date(moment(date.date).toDate()), dateFunctionConfig.dateFormat, { locale: locale[dateFunctionConfig.locale] }) +
            `${date.count ? '- ' + date.count + ' Qnty' : ''}`
        );
      });
      return arr.join(', ');
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'dateTimePipe',
})
export class dateTimePipe implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any): any {
    if (date != '') {
      let splitByHypen = date.split('-');
      let TimePart = splitByHypen[3].split('.');
      let dateTime = `${splitByHypen[0]}-${splitByHypen[1]}-${splitByHypen[2]} ${TimePart[0]}:${TimePart[1]}:${TimePart[2]}`;
      return format(new Date(moment(dateTime).toDate()), dateFunctionConfig.dateMediumFormat + ' ' + dateFunctionConfig.timeFormat, {
        locale: locale[dateFunctionConfig.locale],
      });
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'custDayName',
})
export class CustDayNamePipe implements PipeTransform {
  transform(day: any, dateFunctionConfig?: any): any {
    return format(moment(day, 'YYYY-MM-DD').toDate(), dateFunctionConfig.weekNameFormat, { locale: locale[dateFunctionConfig.locale] });
  }
}

@Pipe({
  name: 'custDayNameChange',
})
export class CustDayNameChangePipe implements PipeTransform {
  transform(day: string, countryCode?: string, dateFunctionConfig?: string): string {
    let dateOptionsLong;
    if (dateFunctionConfig['weekNameFormat'] === 'EEE' || dateFunctionConfig['weekNameFormat'] === 'E..EEE') {
      dateOptionsLong = { weekday: 'short' };
    } else {
      dateOptionsLong = { weekday: 'long' };
    }
    const weekDayName = moment(day).format('dddd');
    if (countryCode == 'EN' || countryCode == 'en-US' || countryCode == 'en-GB') {
      return format(moment(day, 'YYYY-MM-DD').toDate(), dateFunctionConfig['weekNameFormat'], {
        locale: locale[dateFunctionConfig['locale']],
      });
    } else {
      return new Intl.DateTimeFormat(countryCode, dateOptionsLong).format(moment(weekDayName, 'dddd').toDate());
    }
  }
}

@Pipe({
  name: 'custCalDayName',
})
export class custCalDayNamePipe implements PipeTransform {
  transform(day: any, dateFunctionConfig?: any, iMobile: boolean = false): any {
    let countryCode = dateFunctionConfig.locale;
    if (!iMobile)
      if (day.length > 3) return format(moment(day, 'dddd').toDate(), dateFunctionConfig.weekNameFormat, { locale: locale[countryCode] });
      else return format(moment(day, 'ddd').toDate(), dateFunctionConfig.weekNameFormat, { locale: locale[countryCode] });
    else {
      if (day.length > 3) return format(moment(day, 'dddd').toDate(), 'EEE', { locale: locale[countryCode] });
      else return format(moment(day, 'ddd').toDate(), 'EEE', { locale: locale[countryCode] });
    }
  }
}

@Pipe({
  name: 'custCalDayChangeName',
})
export class CustCalDayNameChangePipe implements PipeTransform {
  transform(day: string, dateFunctionConfig?: string, iMobile: boolean = false): string {
    let dateOptionsShort = { weekday: 'short' } as const;
    let dateOptionsLong = { weekday: 'long' } as const;
    let countryCode = dateFunctionConfig || 'en-US';
    if (!iMobile) return new Intl.DateTimeFormat(countryCode, dateOptionsLong).format(moment(day, 'dddd').toDate());
    else {
      return new Intl.DateTimeFormat(countryCode, dateOptionsShort).format(moment(day, 'ddd').toDate());
    }
  }
}

@Pipe({
  name: 'custCalMonthName',
})
export class custCalMonthNamePipe implements PipeTransform {
  transform(day: any, dateFunctionConfig?: any): any {
    return format(moment(day, 'MMMM').toDate(), dateFunctionConfig.monthNameFormat || 'MMMM', {
      locale: locale[dateFunctionConfig.locale],
    });
  }
}

@Pipe({
  name: 'custCalMonth',
})
export class CustCalMonthPipe implements PipeTransform {
  transform(month: string, dateFunctionConfig?: string): string {
    let countryCode = dateFunctionConfig || 'en-US';
    let dateOptionsShort = { month: 'long' } as const;
    return new Intl.DateTimeFormat(countryCode, dateOptionsShort).format(moment(month, 'MMMM').toDate());
  }
}

@Pipe({
  name: 'countryFilter',
})
export class CountryFilter implements PipeTransform {
  transform(countryList: any[], searchText: any) {
    if (searchText && countryList && countryList.length > 0) {
      const filterValue = searchText.toLowerCase();
      countryList = countryList.filter(
        (country) =>
          country.name.toLowerCase().startsWith(filterValue) ||
          country['alpha-2'].toLowerCase().startsWith(filterValue) ||
          country['alpha-3'].toLowerCase().startsWith(filterValue)
      );
      this.setUSACountryToTop(countryList);
      return countryList;
    }
    return countryList;
  }

  /**
   * Sets USA country to the top of list when user searches.
   */
  private setUSACountryToTop(countryList: any[]): void {
    const usaIndex = countryList.findIndex((state) => state.name === 'United States of America');
    if (usaIndex > -1) {
      const usa = countryList[usaIndex];
      countryList.splice(usaIndex, 1);
      countryList.unshift(usa);
    }
  }
}

@Pipe({
  name: 'bookingStatus',
})
export class BookingStatus implements PipeTransform {
  transform(value: any, filter: any) {
    if (filter && filter.length && !!value) {
      let item = filter.find((e) => e.key == value);
      if (item) {
        return item.value;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}

@Pipe({ name: 'plural' })
export class CustomPluralPipe implements PipeTransform {
  transform(input: number, langCode: string, customPluralForm: string = 'S'): string {
    return input > 1 && langCode === 'EN' ? customPluralForm : '';
  }
}
